<template>
  <Register mode="child" />
</template>
<script>
import Register from './Register.vue';
export default { components: { Register } };
</script>
